// @ts-nocheck
import { downloadCSV } from 'react-admin';
import {parseAsync} from 'json2csv';

const DraftChargesExport = (records) => {

    const dataForExport = records.map(record => {
        const {
            id,	processId,	processUuid, endLocationName,
            ...dataForExport } = record; // omit unecessary fields
        // dataForExport.fieldName = record.field.name; // add a field
        // dataForExport.kegSerialNumber = (record.kegs) ? record.kegs.serialNumber : null;

        return dataForExport;
    });

    const fields = [
        {
            label: 'Charge Id',
            value: 'chargeId'
        }, {
            label: 'Organisation Id',
            value: 'organisationId'
        }, {
            label: 'Organisation Name',
            value: 'organisationName'
        }, {
            label: 'Applicable Date',
            value: 'applicableDate'
        }, {
            label: 'Unit Amount',
            value: 'unitAmount'
        }, {
            label: 'Quantity',
            value: 'quantity'
        }, {
            label: 'Total',
            value: 'total'
        }, {
            label: 'Fee Description',
            value: 'description'
        }, {
            label: 'Cycle Id',
            value: 'cycleId'
        }, {
            label: 'Cycle Start Date',
            value: 'cycleStartDate'
        }, {
            label: 'Cycle End Date',
            value: 'cycleEndDate'
        }, {
            label: 'Keg Serial Number',
            value: 'kegSerialNumber'
        }, {
            label: 'SKU',
            value: 'skuName'
        }, {
            label: 'Cycle End Location',
            value: 'cycleEndLocation'
        }, {
            label: 'Cycle End Role',
            value: 'cycleEndRole'
        }, {
            label: 'Cycle End Region',
            value: 'cycleEndRegion'
        }, {
            label: 'Order Id',
            value: 'orderId'
        }];

    const opts = {fields};

    parseAsync(dataForExport, opts)
        .then(csv => {
            let today = new Date();
            downloadCSV(csv, 'DraftCharges_' + today.toISOString().split('T')[0]); // download as 'posts.csv` file
        })
        .catch(err => console.error(err));

};

export default DraftChargesExport;
